import $ from "jquery";

$(function() {
    $(".bl-vorfallform").each(function() {
        const $bl = $(this);
        initBlock($bl);
    });
});

function initBlock($bl) {
    const $btn = $bl.find(".btnshowform");
    const $form = $bl.find(".vorfallform");
    $btn.on("click", function() {
        $form.slideDown(200);
    });
}

